<template>
  <StaticPage ref="staticPage">
    <div
      class="form_wrapper left-panel flex items-center justify-center !h-full min-h-[20vh] xxs:min-h-[50vh] md:min-h-[60vh]"
    >
      <div class="customHandling" v-if="customHandling.includes(this.errorCode)">
        <div class="form_logo" :style="{ paddingTop: 0 }">
          <img alt />
        </div>
        <div class="from_box">
          <div class="main" v-if="errorCode === 410">
            <p v-html="$t('loginClient.error.blacklistedReferrer')"></p>
            <el-button class="el-button blue_button" @click="goToCreateLiveAcc()" data-testid="createLiveAccount">
              {{ $t('loginClient.error.createLiveAccount') }}
            </el-button>
          </div>

          <div class="main" v-if="errorCode === 409">
            <p v-html="$t('loginClient.error.registerBlacklist')"></p>
            <a class="el-button blue_button" :href="`https://${url}`" data-testid="goToHomePage">
              {{ $t('common.button.bkToHm') }}
            </a>
          </div>

          <div class="main" v-if="errorCode === 407 || errorCode === 408">
            <p v-html="$t('loginClient.error.existingClientPortalAccess')"></p>
            <router-link to="/login" class="el-button blue_button">
              {{ $t('common.button.login') }}
            </router-link>
            <small>{{ $t('loginClient.error.tip') }}</small>
            <router-link to="/forgetPassword" class="el-button white_button">
              {{ $t('common.button.reset') }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="default" v-else>
        <p class="title">{{ $t('responseMsg.' + errorCode) }}</p>
        <p class="main">
          <a :href="`https://${url}`">Click here</a>
          to go back to the {{ $config.info.fullName }} homepage, or
          <a :href="'mailto:' + email"> send us an email </a>
          to let us know you've encountered an error.
        </p>
        <p class="code">Error code : {{ errorCode }}</p>
      </div>
    </div>
  </StaticPage>
</template>

<script>
import StaticPage from '@/components/template/StaticPage';

export default {
  components: { StaticPage },
  data() {
    return {
      url: '',
      email: '',
      errorCode: 0,
      customHandling: [407, 408, 409, 410]
    };
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    },
    // this.$store.state.common.regulator === null if no login
    regulator() {
      return this.$store.state.common.regulator ?? 'svg';
    },
    GLOBAL_DOMAIN_WEBSITE() {
      return this.$store.state.regulator.domainWebSite || this.$config.info.getUrl(this.regulator);
    },
    GLOBAL_DOMAIN_WEBSITECN() {
      return this.$store.state.regulator.domainWebSiteCn || this.$config.info.getUrlCn(this.regulator);
    },
    GLOBAL_DOMAIN_WEBSITETW() {
      return this.$config.info.getUrlTw(this.regulator);
    },
    languagePath() {
      switch (this.lang) {
        case 'zh_CN':
          return this.GLOBAL_DOMAIN_WEBSITECN;
        case 'zh_TW':
          return this.GLOBAL_DOMAIN_WEBSITETW;
        default:
          return this.GLOBAL_DOMAIN_WEBSITE;
      }
    }
  },
  methods: {
    goToCreateLiveAcc() {
      const languagePath = this.languagePath;
      const languageSuffix = !['th'].includes(this.lang) ? '' : '/' + this.lang;

      let url = `https://${languagePath}${languageSuffix}/forex-trading/forex-trading-account?c=null`;

      window.open(url, '_blank', 'noopener,noreferrer');
    }
  },
  mounted() {
    this.errorCode = parseInt(this.$route.query.code);
    this.url = this.$refs.staticPage.url;
    this.email = this.$refs.staticPage.email;
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/register/error.scss';
</style>
